
import Vue from 'vue';
import _isNil from 'lodash/isNil';
import NumberWithIncrementer from '@/components/base/NumberWithIncrementer.vue';

export default Vue.extend({
	name: 'BaseSlider',
	props: {
		isCurrency: { type: Boolean, default: false },
		incrementerPadding: { type: String, default: '0 0 0 0' },
		condensedIncrementer: { type: Boolean, default: false },
		numberMinWidth: { type: String, default: () => '40px' },
		// Widens the editable number box past NumberWithIncrementer's 60px default, which only fits
		// ~3 digits. Also widens the space reserved for it in the slider's append slot.
		incrementerMaxWidth: { type: String, default: null },
		// Leave typed entry alone until blur. Matters on coarse steps, where rounding every keystroke
		// rewrites digits as they are typed.
		roundToNearestStepOnlyOnBlur: { type: Boolean, default: false },
		editableNumberInput: { type: Boolean, default: false },
		hideBackground: { type: Boolean, default: false },
	},
	data () {
		return {
			visibleValue: null,
		};
	},
	watch: {
		'$attrs.value': {
			immediate: true,
			handler (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.visibleValue = newVal;
				}
			}
		},
	},
	methods: {
		_isNil,
		onIncrement (val: number) {
			this.$emit('input', val);
			this.$emit('change', val);
		},
		onInput (val: number) {
			this.visibleValue = val;
		},
	},
	components: {
		NumberWithIncrementer,
	},
});
